import { API, getRequest } from 'utils/request';
import action from './actions';

/**
 * Github repos request/response handler
 */
export const fetchVisuals = async () => {
  try {
    const res: any = await getRequest(`${API.getVisuals}`);
    return res.data || [];
  } catch (err) {
    console.log(err);
    return [];
  }
};
export const fetchVisualization = async (pathname: string) => {
  try {
    const visualId = `${pathname.substring(
      pathname.lastIndexOf('/') + 1,
      pathname.length,
    )}`;
    const res: any = await getRequest(`${API.getSingleVisuals}/${visualId}`);

    return res.data || {};
  } catch (err) {
    console.log(err);
    return {};
  }
};
